// MedReg AI surum dizesi. go/internal/platform/config/version.go ile
// senkron tutulmali (release commit'inde ikisi birlikte guncellenir).
export const VERSION = "20261014.03";
